import React, { useState, useEffect } from "react";
import Editor from "@monaco-editor/react";

import Button from "../ui/Button";

import Modal from "../ui/Modal";

export default function BrochureExtractData({
  details,
  isBrochureExtractDataOpen,
  onCloseBrochureExtractData,
}) {
  // ✅

  const [jsonText, setJsonText] = useState("");

  useEffect(() => {
    console.log("📄 extractedPdfData received:", details);

    if (details) {
      const formattedJson = JSON.stringify(details, null, 2);

      setJsonText(formattedJson);
    }
  }, [details]);

  const handleSave = () => {
    try {
      console.log("📝 Raw Editor Content:");
      console.log(jsonText);

      const parsedData = JSON.parse(jsonText);

      console.log("✅ Parsed JSON:");
      console.log(parsedData);

      onCloseBrochureExtractData();
    } catch (error) {
      console.error("❌ Invalid JSON. Fix the JSON before saving.");

      console.error(error);

      alert("Invalid JSON. Please fix errors.");
    }
  };

  const handleClose = () => {
    console.log("❌ Modal Closed");

    onCloseBrochureExtractData();
  };

  return (
    <Modal
      isOpen={isBrochureExtractDataOpen}
      title="Extracted PDF Data"
      size="xl"
      onClose={handleClose}
    >
      <div className="d-flex flex-column gap-3" style={{ height: "80vh" }}>
        <div
          style={{
            flex: 1,
            border: "1px solid #ddd",
            overflow: "hidden",
          }}
        >
          <Editor
            height="100%"
            defaultLanguage="json"
            value={jsonText}
            theme="vs-dark"
            options={{
              minimap: {
                enabled: false,
              },
              fontSize: 14,
              wordWrap: "on",
              automaticLayout: true,
              formatOnPaste: true,
              formatOnType: true,
            }}
            onChange={(value) => {
              console.log("⌨️ JSON Updated");

              setJsonText(value || "");
            }}
          />
        </div>

        <div className="action-container mb-3">
          <Button variant="outline" size="md" onClick={handleClose}>
            Cancel
          </Button>

          <Button variant="primary" size="md" onClick={handleSave}>
            Save JSON
          </Button>
        </div>
      </div>
    </Modal>
  );
}
